import { wtProfile } from './wt.js';

export const utilities = {

  data() {
    return {
      sdata: null,
      udata: null,
      defaultWTProfile: wtProfile,
      emptyguid: "00000000-0000-0000-0000-000000000000",
      theseOrgs: [],
      theseGroups: [],
      thesePools: []
    }
  },
  methods: {

    addThemeSetting(cls, subcls, rule, usecls) {
      if (document.getElementById("thm_" + cls + "_" + subcls) === null) {
        var style = document.createElement("style");
        style.id = "thm_" + cls + "_" + subcls;
        (document.head || document.documentElement).appendChild(style);
        style.innerHTML = (usecls ? "." : "") + cls + "{" + rule + " !important; }";
      }
    },

    async apiCommand(cmds, noload) {

      if (this.udata === null) {
        try {
          this.udata = JSON.parse(localStorage.getItem("udata"));
        }
        catch (e) { }
      }

      // Check for expired session
      if (this.udata === null || typeof (this.udata.SessionID) === "undefined" || this.udata.expiry < new Date().getTime()) {       
        this.failback();
      }
      else {
        var self = this;
        if (!(typeof (noload) !== "undefined" && noload !== null)) {
          self.startLoading();
        }

        return await this.$http({
          method: 'post',
          url: this.$hostname + '/TCAPI.svc/Command',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: {
            SessionID: typeof (this.udata.ClientID) === "undefined" ? this.emptyguid : this.udata.SessionID,
            PortalID: "7728DEAD-2980-4748-9213-D49B97B74AE8",
            SLong: typeof (this.udata.ClientID) === "undefined" ? "" : this.udata.SLong,
            Commands: cmds
          }
        }).then(response => {

          if (!(typeof (noload) !== "undefined" && noload !== null)) {
            self.endLoading();
          }
          if (response.status === 200) {
            return response.data;
          }

          return null;

        }).catch(error => {
          if (!(typeof (noload) !== "undefined" && noload !== null)) {
            self.endLoading();
          }
          return null;
        });

      }

      return null;
    },

    applyTheme(thm) {

      if (thm.Logo !== null && thm.Logo.length > 0) {
        this.$bus.$emit("LogoUpdateEvent", thm.Logo);
      }


      this.removeThemeSetting("mainbody", "backgroundcolor");
      this.removeThemeSetting("card", "background");
      this.removeThemeSetting("card-title h3", "color");
      this.removeThemeSetting("card-links a", "color");
      this.removeThemeSetting("table", "color");
      this.removeThemeSetting("topbox", "background-color");
      this.removeThemeSetting("body", "color");
      this.removeThemeSetting("a", "color");
      this.removeThemeSetting("tabletitle", "color");
      this.removeThemeSetting("acsidebar h3", "color");
      this.removeThemeSetting("tablesettings svg", "color");
      this.removeThemeSetting("btn-transparent-white", "color");
      this.removeThemeSetting("btn-transparent-white svg", "color");
      this.removeThemeSetting("wtColumnHeader", "backgroundcolor");
      this.removeThemeSetting("div#headerbar.license-pool-administrator:before", "background");
      this.removeThemeSetting("div#headerbar.license-pool-data-viewer:before", "background");
      this.removeThemeSetting("div#headerbar.group-administrator:before", "background");
      this.removeThemeSetting("div#headerbar.group-data-viewer:before", "background");
      this.removeThemeSetting("div#headerbar:before", "background");
      this.removeThemeSetting("bubblebutton svg", "color");
      this.removeThemeSetting("acsidebar", "backgroundcolor");
      this.removeThemeSetting("accountstatus", "color");
      this.removeThemeSetting("sidebarlinks a", "color");
      this.removeThemeSetting("footer.simfooter", "backgroundcolor");
      this.removeThemeSetting("footer.simfooter p", "color");
      this.removeThemeSetting("footer.simfooter h6", "color");
      this.removeThemeSetting("footer.simfooter a", "color");
      this.removeThemeSetting("dropdown a", "color");
      this.removeThemeSetting("btn-secondary", "backgroundcolor");
      this.removeThemeSetting("btn-secondary", "bordercolor");
      this.removeThemeSetting("btn-secondary", "color");
      this.removeThemeSetting("btn-primary", "backgroundcolor");
      this.removeThemeSetting("btn-primary", "bordercolor");
      this.removeThemeSetting("btn-primary", "color");

      this.addThemeSetting("mainbody", "backgroundcolor", "background-color: " + thm.BackgroundColor, true);
      this.addThemeSetting("card", "background", "background: " + thm.CardColor, true);
      this.addThemeSetting("card-title h3", "color", "color: " + thm.CardFontColor, true);
      this.addThemeSetting("card-links a", "color", "color: " + thm.CardLinkColor, true);
      this.addThemeSetting("table", "color", "color: " + thm.WonderTableColor, true);
      this.addThemeSetting("topbox", "background-color", "background-color: " + thm.WonderHeaderColor, true);
      this.addThemeSetting("body", "color", "color: " + thm.TextColor, false);
      this.addThemeSetting("a", "color", "color: " + thm.LinkColor, false);
      this.addThemeSetting("tabletitle", "color", "color: " + thm.HeadingColor, true);
      this.addThemeSetting("acsidebar h3", "color", "color: " + thm.HeadingColor, true);
      this.addThemeSetting("tablesettings svg", "color", "color: " + thm.HeadingColor, true);
      this.addThemeSetting("btn-transparent-white", "color", "color: " + thm.WonderHeaderTextColor, true);
      this.addThemeSetting("btn-transparent-white svg", "color", "color: " + thm.WonderHeaderTextColor, true);
      this.addThemeSetting("wtColumnHeader", "backgroundcolor", "background-color: " + thm.WonderHeaderColor, true);
      this.addThemeSetting("div#headerbar.license-pool-administrator:before", "background", "background: " + thm.PoolAdminRoleColor, false);
      this.addThemeSetting("div#headerbar.license-pool-data-viewer:before", "background", "background: " + thm.PoolDataViewerRoleColor, false);
      this.addThemeSetting("div#headerbar.group-administrator:before", "background", "background: " + thm.GroupAdminRoleColor, false);
      this.addThemeSetting("div#headerbar.group-data-viewer:before", "background", "background: " + thm.GroupDataViewerRoleColor, false);
      this.addThemeSetting("div#headerbar:before", "background", "background: " + thm.HeadingColor, false);
      this.addThemeSetting("bubblebutton svg", "color", "color: " + thm.CartBubbleColor, true);
      this.addThemeSetting("acsidebar", "backgroundcolor", "background-color: " + thm.LeftMenuBackgroundColor, true);
      this.addThemeSetting("accountstatus", "color", "color: " + thm.LeftMenuRoleColor, true);
      this.addThemeSetting("sidebarlinks a", "color", "color: " + thm.LeftMenuLinkColor, true);
      this.addThemeSetting("footer.simfooter", "backgroundcolor", "background-color: " + thm.FooterBackgroundColor, false);
      this.addThemeSetting("footer.simfooter p", "color", "color: " + thm.FooterTextColor, false);
      this.addThemeSetting("footer.simfooter h6", "color", "color: " + thm.FooterColumnHeaderColor, false);
      this.addThemeSetting("footer.simfooter a", "color", "color: " + thm.FooterMenuColor, false);
      this.addThemeSetting("dropdown a", "color", "color: " + thm.TopRightMenuColor, true);
      this.addThemeSetting("btn-secondary", "backgroundcolor", "background-color: " + thm.ButtonRolloverColor, true);
      this.addThemeSetting("btn-secondary", "bordercolor", "border-color: " + thm.ButtonRolloverColor, true);
      this.addThemeSetting("btn-secondary", "color", "color: " + thm.ButtonRolloverTextColor, true);
      this.addThemeSetting("btn-primary", "backgroundcolor", "background-color: " + thm.ButtonBackground, true);
      this.addThemeSetting("btn-primary", "bordercolor", "border-color: " + thm.ButtonBackground, true);
      this.addThemeSetting("btn-primary", "color", "color: " + thm.ButtonTextColor, true);

    },

    bootstrapClear() {
      this.theseGroups = [];
      this.theseOrgs = [];
      this.thesePools = [];
    },

    bootstrapClient(cliID) {
      this.bootstrapClear();

      try {
        if (typeof (this.sdata.poolthemes) !== "undefined" && this.sdata.poolthemes !== null && this.sdata.poolthemes.length > 0 && this.sdata.isemployee !== true) {

          if (this.sdata.poolthemes[0].UsesBranding) {
            this.applyTheme(this.sdata.poolthemes[0]);
          }

        }
      }
      catch (e) { }

      this.$bus.$emit("AvatarUpdateEvent", this.udata);

      this.$bus.$emit("BreadcrumbUpdateEvent", this.sdata.allorgs, this.sdata.allpools, this.sdata.allgroups, null, null, null);
      this.$bus.$emit("ClientSidebarUpdateEvent", this.udata.ClientName, this.udata.ClientID, this.sdata.sidebarenabled);
    },

    bootstrapGroup(groupID) {
      this.bootstrapClear();

      this.$bus.$emit("AvatarUpdateEvent", this.udata);

      try {
        if (typeof (this.sdata.poolthemes) !== "undefined" && this.sdata.poolthemes !== null && this.sdata.poolthemes.length > 0 && this.sdata.isemployee !== true) {

          if (this.sdata.poolthemes[0].UsesBranding) {
            this.applyTheme(this.sdata.poolthemes[0]);
          }

        }
      }
      catch (e) { }

      for (var group of this.sdata.allgroups.filter(p => p.LicensePoolGroupID === groupID)) {
        this.sdata.activegroup = group;

      }

      for (var pool of this.sdata.allpools.filter(p => p.LicensePoolID === this.sdata.activegroup.LicensePoolID)) {
        this.sdata.activepool = pool;

      }

      for (var org of this.sdata.allorgs.filter(p => p.OrganizationID === this.sdata.activepool.OrganizationID)) {
        this.sdata.activeorg = org;
        localStorage.setItem("orgNamePreference", org.NameFormat);
      }


      if (this.sdata.activeorg !== null && this.sdata.isemployee !== true) {
        for (var pool of this.sdata.allpools.filter(p => p.OrganizationID === this.sdata.activeorg.OrganizationID)) {
          this.thesePools.push(pool)
        }
      }
      else {
        for (var pool of this.sdata.allpools) {
          this.thesePools.push(pool)
        }
      }

      if (this.sdata.activepool !== null) {
        for (var group of this.sdata.allgroups.filter(p => p.LicensePoolID === this.sdata.activepool.LicensePoolID)) {
          this.theseGroups.push(group)
        }
      }
      else {
        for (var group of this.sdata.allgroups) {
          this.theseGroups.push(group)
        }
      }

      this.$bus.$emit("BreadcrumbUpdateEvent", this.sdata.allorgs, this.thesePools, this.theseGroups,
        this.sdata.activeorg !== null ? this.sdata.activeorg.OrganizationID : null,
        this.sdata.activepool !== null ? this.sdata.activepool.LicensePoolID : null,
        this.sdata.activegroup.LicensePoolGroupID);

      this.$bus.$emit("GroupSidebarUpdateEvent", this.sdata.activegroup.IsAdmin, this.sdata.activegroup, this.sdata.activepool !== null, this.sdata.activepool !== null && this.sdata.activepool.IsAdmin ? true : false, this.sdata.sidebarenabled);
    },

    bootstrapOrg(orgID) {

      this.bootstrapClear();

      this.$bus.$emit("AvatarUpdateEvent", this.udata);

      try {
        if (typeof (this.sdata.poolthemes) !== "undefined" && this.sdata.poolthemes !== null && this.sdata.poolthemes.length > 0 && this.sdata.isemployee !== true) {

          if (this.sdata.poolthemes[0].UsesBranding) {
            this.applyTheme(this.sdata.poolthemes[0]);
          }

        }
      }
      catch (e) { }


      for (var org of this.sdata.allorgs.filter(p => p.OrganizationID === orgID)) {

        this.sdata.activeorg = org;
        localStorage.setItem("orgNamePreference", org.NameFormat);
      }

      for (var pool of this.sdata.allpools.filter(p => p.OrganizationID === orgID)) {
        this.thesePools.push(pool)
      }

      for (var group of this.sdata.allgroups.filter(p => this.thesePools.indexOf(p.LicensePoolID) !== -1)) {
        this.theseGroups.push(group);
      }

      this.$bus.$emit("BreadcrumbUpdateEvent", this.sdata.allorgs, this.thesePools, this.theseGroups, orgID, null, null);
      this.$bus.$emit("OrgSidebarUpdateEvent", this.sdata.ispro, this.sdata.activeorg, this.sdata.sidebarenabled);
    },

    bootstrapPool(poolID) {

      this.bootstrapClear();

      this.$bus.$emit("AvatarUpdateEvent", this.udata);

      var pt = null;

      try {
        if (typeof (this.sdata.poolthemes) !== "undefined" && this.sdata.poolthemes !== null && this.sdata.poolthemes.length > 0 && this.sdata.isemployee !== true) {

          if (this.sdata.poolthemes[0].UsesBranding) {
            this.applyTheme(this.sdata.poolthemes[0]);
          }

        }
      }
      catch (e) { }


      for (var pool of this.sdata.allpools.filter(p => p.LicensePoolID === poolID)) {
        this.sdata.activepool = pool;
      }

      for (var org of this.sdata.allorgs.filter(p => p.OrganizationID === this.sdata.activepool.OrganizationID)) {
        this.sdata.activeorg = org;

        localStorage.setItem("orgNamePreference", org.NameFormat);
      }

      if (this.sdata.activeorg !== null && this.sdata.isemployee !== true) {
        for (var pool of this.sdata.allpools.filter(p => p.OrganizationID === this.sdata.activeorg.OrganizationID)) {
          this.thesePools.push(pool)
        }
      }
      else {
        for (var pool of this.sdata.allpools) {
          this.thesePools.push(pool)
        }
      }

      for (var group of this.sdata.allgroups.filter(p => p.LicensePoolID === this.sdata.activepool.LicensePoolID)) {
        this.theseGroups.push(group);
      }

      this.$bus.$emit("BreadcrumbUpdateEvent", this.sdata.allorgs, this.thesePools, this.theseGroups, this.sdata.activeorg !== null ? this.sdata.activeorg.OrganizationID : null, this.sdata.activepool.LicensePoolID, null);
      this.$bus.$emit("PoolSidebarUpdateEvent", this.sdata.activepool.IsAdmin, this.sdata.activepool, this.sdata.activeorg !== null && this.sdata.activeorg.IsAdmin ? true : false, this.sdata.sidebarenabled);
    },

    buildMemberStatus(PoolName, VerificationID, LicensePoolID, ClientID, IsAdmin) {
      try {
        var rm = "";
        if (IsAdmin) {
          rm = " [<a href='javascript:void(0)' role='button' onclick='window.resendInvite(\"" + ClientID + "\")'>Resend</a>] [<a href='javascript:void(0)' role='button' onclick='window.removeInvite(\"" + LicensePoolID + "\")'>Delete</a>]";
        }
        if (PoolName.indexOf("SIMINVITED") > -1) {
          return "Invited" + rm;
        }
      }
      catch (e) {

      }

      return VerificationID === this.emptyguid ? "Verified" : "Not Verified";
    },

    buildDateTime(dt, lngformat, timeonly) {
      try {
        if (dt.length > 20) {
          var dtp = dt.split('-');
          dt = dtp[0] + "-" + dtp[1] + "-" + dtp[2];
        }
        var dto = null;

        if (dt.indexOf("Z") === -1) {
          dto = new Date(dt + "Z");
        }
        else {
          dto = new Date(dt);
        }
        var hr = dto.getHours();
        var pma = "AM";
        if (hr > 11) {
          pma = 'PM';
          hr -= 12;
        }
        if (hr === 0) {
          hr = 12;
        }
        hr = String(hr);
        if (hr.length == 1) {
          hr = "0" + hr;
        }

        var mt = dto.getMonth() + 1;
        var dtd = String(dto.getDate());
        switch (mt) {
          case 1: mt = "January"; break;
          case 2: mt = "February"; break;
          case 3: mt = "March"; break;
          case 4: mt = "April"; break;
          case 5: mt = "May"; break;
          case 6: mt = "June"; break;
          case 7: mt = "July"; break;
          case 8: mt = "August"; break;
          case 9: mt = "September"; break;
          case 10: mt = "October"; break;
          case 11: mt = "November"; break;
          case 12: mt = "December"; break;
        }

        var min = dto.getMinutes();
        if (min < 10) {
          min = "0" + min;
        }

        if (typeof (timeonly) !== "undefined") {
          return hr + ":" + min + " " + pma;
        }
        else {
          if (lngformat) {
            return mt + " " + dtd + ", " + dto.getFullYear() + " " + hr + ":" + min + " " + pma;
          }
          else {
            return mt + " " + dtd + ", " + dto.getFullYear();
          }
        }

      }
      catch (e) {
        return null;
      }
    },

    buildGroupHierarchy(groupID, groups, isAdmin, hasEdit) {

      var groupHierarchy = [];

      for (var x = 0; x < groups.length; x++) {
        if (groups[x].ParentID === groupID) {

          var links = [];

          if (isAdmin) {
            links = [{
              Address: { name: "grouptags", params: { id: groups[x].LicensePoolGroupID } },
              Icon: "tag",
              Label: "Manage tags"
            }
            ];
            if (hasEdit) {
              links.push({
                Address: { name: "groupedit", params: { id: groups[x].LicensePoolGroupID } },
                Icon: "edit",
                Label: "Edit group"
              });
            }

          }

          groupHierarchy.push({
            Name: groups[x].LicensePoolGroupName,
            Address: { name: "groupdash", params: { id: groups[x].LicensePoolGroupID } },
            Children: [],
            GroupID: groups[x].LicensePoolGroupID,
            ParentID: groups[x].ParentID,
            Tags: typeof (groups[x].Tags) !== "undefined" ? groups[x].Tags : groups[x].LicensePoolGroupTags,
            MemberCount: groups[x].MemberCount,
            Additional: null,
            Links: links
          });
        }
      }

      for (var y = 0; y < groupHierarchy.length; y++) {
        groupHierarchy[y].Children = this.buildGroupHierarchy(groupHierarchy[y].GroupID, groups, isAdmin, hasEdit);
        groupHierarchy[y].Additional = " [" + groupHierarchy[y].MemberCount + " <span name='members_2'>Members</span>]";

        if (groupHierarchy[y].Tags.length > 0) {
          groupHierarchy[y].Additional += "&nbsp;&nbsp;&nbsp;<span style='font-size:12px;'>(";


          for (var t of groupHierarchy[y].Tags) {
            groupHierarchy[y].Additional += "<img src='/tagIcon.png' height='10' alt='' role='presentation' /> " + t.TagName;
            groupHierarchy[y].Additional += ", ";
          }

          groupHierarchy[y].Additional = groupHierarchy[y].Additional.slice(0, -2);

          groupHierarchy[y].Additional += ")</span>";
        }
      }

      return groupHierarchy;
    },

    buildNameFormat(FirstName, LastName, NameFormat) {
      var uString = "";
      var udata = JSON.parse(localStorage.getItem("udata"));
      var nformat = 0;


      try {
        FirstName = FirstName.trim();
        FirstName = this.capitalize(FirstName);
      }
      catch (e) { }

      try {
        LastName = LastName.trim();
        LastName = this.capitalize(LastName);
      }
      catch (e) { }

      var orgnameformat = null;
      try {
        orgnameformat = localStorage.getItem("orgNamePreference");
      }
      catch (e) { }


      if (udata.NameFormat !== null && udata.NameFormat < 2) {
        try {
          nformat = parseInt(udata.NameFormat);
        }
        catch (e) { }
      }
      else if (orgnameformat !== null) {
        try {
          nformat = orgnameformat;
        }
        catch (e) { }
      }

      if (nformat === 0) {
        if (FirstName) {
          uString += FirstName + " ";
        }
        if (LastName) {
          uString += LastName + " ";
        }
      }
      else {
        if (FirstName && LastName) {
          uString += LastName + ", " + FirstName + " ";
        }
        else if (FirstName) {
          uString += FirstName + " ";
        }
        else if (LastName) {
          uString += LastName + " ";
        }
      }

      return uString;
    },

    buildSimUser(ClientID, Username, Email, FirstName, LastName, IncludeLink, IncludeAvatar, NameFormat) {
      var uString = this.buildNameFormat(FirstName, LastName, NameFormat);

      if (Email) {
        if (FirstName || LastName) {
          uString += "(" + Email + ")";
        }
        else {
          uString += Email;
        }
      }
      else {
        if (FirstName || LastName) {
          uString += "(" + Username + ")";
        }
        else {
          uString += Username;
        }
      }

      uString = this.decodeHtml(uString);

      if (uString.length > 65) {
        uString = uString.substring(0, 50) + "...";
      }

      var avatarCode = "";
      if (IncludeAvatar) {
        avatarCode = "<img src='https://attachments.simmersion.com/" + ClientID + ".png' class='avatar' onerror='this.src=\"/genericAvatar.png\"' height='20' width='20' role='presentation' alt='' />&nbsp;&nbsp;"
      }

      if (IncludeLink) {
        return avatarCode + "<a href='/client/" + ClientID + "'>" + uString + "</a>";
      }
      else {
        return avatarCode + uString;
      }
    },
 buildSimUserEmail(ClientID, Username, Email, FirstName, LastName, IncludeLink, IncludeAvatar, NameFormat) {
      var uString = this.buildNameFormat(FirstName, LastName, NameFormat);

      if (Email) {
          uString = Email;
      }
      else {       
          uString = Username;        
      }

      uString = this.decodeHtml(uString);

      if (uString.length > 65) {
        uString = uString.substring(0, 50) + "...";
      }

      var avatarCode = "";
      if (IncludeAvatar) {
        avatarCode = "<img src='https://attachments.simmersion.com/" + ClientID + ".png' class='avatar' onerror='this.src=\"/genericAvatar.png\"' height='20' width='20' role='presentation' alt='' />&nbsp;&nbsp;"
      }

      if (IncludeLink) {
        return avatarCode + "<a href='/client/" + ClientID + "'>" + uString + "</a>";
      }
      else {
        return avatarCode + uString;
      }
    },

    capitalize(n) {
      if (n === null || n.length === 0) return n;
      n = n.toLowerCase();
      return n.charAt(0).toUpperCase() + n.slice(1);
    },

    collapseSidebar() {
      var mb = document.getElementsByClassName("mainbody")[0];
      mb.children[0].removeAttribute("class");
      mb.children[1].removeAttribute("class");
      mb.children[0].setAttribute("class", "collapsedLeft");
      mb.children[1].setAttribute("class", "collapsedRight");
      this.udata = JSON.parse(localStorage.getItem("udata"));
      this.udata.sidebarenabled = false;
      localStorage.setItem("udata", JSON.stringify(this.udata));
      this.sdata = JSON.parse(localStorage.getItem("sdata"));
      this.sdata.sidebarenabled = false;
      localStorage.setItem("sdata", JSON.stringify(this.sdata));

    },

    deCollapseSidebar() {
      var mb = document.getElementsByClassName("mainbody")[0];
      mb.children[0].removeAttribute("class");
      mb.children[1].removeAttribute("class");
      mb.children[0].setAttribute("class", "col-lg-2 col-md-4 col-sm-12");
      mb.children[1].setAttribute("class", "col-lg-10 col-md-8 col-sm-12");
      this.udata = JSON.parse(localStorage.getItem("udata"));
      this.udata.sidebarenabled = true;
      localStorage.setItem("udata", JSON.stringify(this.udata));
      this.sdata = JSON.parse(localStorage.getItem("sdata"));
      this.sdata.sidebarenabled = true;
      localStorage.setItem("sdata", JSON.stringify(this.sdata));
    },

    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    async doLogin(email, pass, remember) {

      if (email && pass) {

        return await this.$http({
          method: 'post',
          url: this.$hostname + '/TCAPI.svc/Authenticate',
          //url: "http://localhost:62377/TCAPI.svc/Authenticate",
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: {
            _U: email,
            _P: pass,
            _R: "7728DEAD-2980-4748-9213-D49B97B74AE8"
          }
        }).then(response => {

          var res = -1;
          debugger;
          switch (response.data.AuthenticateResult) {
            case null: res = 0; break;
            case "null": res = 0; break;
            case "Verification Required": res = 1; break;
            case "Archived Account": res = 2; break;
            case "Account Overriden by SAML": res = 3; break;
            case "Authentication Failed": res = 0; break;
            case "Organization login required": res = 5; break;
          }

          if (res === -1) {
            this.udata = JSON.parse(response.data.AuthenticateResult);
            this.udata.expiry = new Date().getTime() + 60 * 60 * 24 * 1000;
            localStorage.setItem("udata", JSON.stringify(this.udata));
            sessionStorage.setItem("isSimmersionUser", '');

            if (remember) {
              try {
                localStorage.setItem("7728DEAD-2980-4748-9213-D49B97B74AE8_u", email);
                localStorage.setItem("7728DEAD-2980-4748-9213-D49B97B74AE8_p", pass);
              }
              catch (e) { }
            }

          }

          return new Promise(function (resolve, reject) { resolve(res); });
        });

      }

      return new Promise(function (resolve, reject) { resolve(null); });
    },

    doLogout() {

      return this.apiCommand([
        {
          Operation: "LoginSession",
          Function: "Logout",
          Fields: {}
        }
      ]).then(response => {

        localStorage.removeItem("udata");
        localStorage.removeItem("isSSOLogin");
        this.$router.push("/");

      });

    },

    async doPage(forceReload) {

      try {
        if (this.udata === null) {
          this.udata = JSON.parse(localStorage.getItem("udata"));
          this.sdata = JSON.parse(localStorage.getItem("sdata"));
        }

        if ((this.sdata !== null && this.sdata.isloaded === true) && typeof (forceReload) === "undefined") {
          // Force refresh every 5 minutes
          if (new Date().getTime() - this.sdata.expiry < 300000) {
            this.setupInbox();
            this.sdata.sidebareneabled = this.udata.sidebarenabled;
            return new Promise(function (resolve, reject) { resolve(true); });
          }

        }

        return await this.apiCommand([
          {
            Operation: "Client",
            Function: "GetAdminDashboard",
            Fields: {}
          }
        ]).then(response => {

          if (response !== null) {

            var cr = JSON.parse(response.CommandResult);
            if (cr.isLoggedIn) {

              this.sdata = {
                hasreporting: false,
                ispro: false,
                allorgs: [],
                allpools: [],
                allgroups: [],
                activeorg: null,
                activegroup: null,
                activepool: null,
                isemployee: false,
                isloaded: false,
                expiry: new Date().getTime(),
                poolthemes: [],
                sidebarenabled: this.udata.sidebarenabled
              }


              if (cr.pR == 3) {
                this.sdata.isemployee = true;
              }

              var adata = JSON.parse(cr.returnObjects[0].returnObject);
              this.sdata.ispro = adata.IsPro;
              this.sdata.hasreporting = adata.HasReporting;


              try {
                localStorage.setItem("orgNamePreference", adata.Orgs[0].NameFormat);
              }
              catch (e) { }

              var orgElements = [];
              var poolElements = [];
              var groupElements = [];

              for (var org of adata.Orgs) {
                org.ScrollElement = null;
                org.FullImage = "https://attachments.simmersion.com/" + org.OrganizationID + ".png";
                if (orgElements.indexOf(org.OrganizationName[0].toUpperCase()) === -1) {
                  orgElements.push(org.OrganizationName[0].toUpperCase());
                  org.ScrollElement = org.OrganizationName[0].toUpperCase();
                }

                if (org.IsAdmin) {
                  this.sdata.allorgs.push(org);
                }
                if (org.Theme !== null) {
                  this.sdata.poolthemes.push(org.Theme);
                }


                for (var pool of org.PoolsToAdminister) {
                  pool.ScrollElement = null;
                  pool.FullImage = this.$hostname + "/Streamable.svc/GetImage?type=pool&ID=" + pool.LicensePoolID;
                  if (poolElements.indexOf(pool.LicensePoolName[0].toUpperCase()) === -1) {
                    poolElements.push(pool.LicensePoolName[0].toUpperCase());
                    pool.ScrollElement = pool.LicensePoolName[0].toUpperCase();
                  }

                  if (org.IsAdmin) {
                    pool.IsAdmin = true;
                  }
                  else {

                    var pa = org.PoolAdminPrivileges.filter(p => p.LicensePoolID === pool.LicensePoolID);
                    if (pa.length > 0) {
                      if (pa[0].LicensePoolAdminType === 1) {
                        pool.IsAdmin = true;
                      }
                      else {
                        pool.IsAdmin = false;
                      }
                    }
                    else {
                      pool.IsAdmin = false;
                    }


                  }
                  this.sdata.allpools.push(pool);
                }


                for (var group of org.GroupsToAdminister) {
                  group.ScrollElement = null;
                  group.FullImage = this.$hostname + "/Streamable.svc/GetImage?type=pool&ID=" + group.LicensePoolID;
                  if (groupElements.indexOf(group.LicensePoolGroupName[0].toUpperCase()) === -1) {
                    groupElements.push(group.LicensePoolGroupName[0].toUpperCase());
                    group.ScrollElement = group.LicensePoolGroupName[0].toUpperCase();
                  }
                  if (org.IsAdmin) {
                    group.IsAdmin = true;
                  }
                  else {

                    var pa = org.GroupAdminPrivileges.filter(p => p.LicensePoolGroupID == group.LicensePoolGroupID);
                    if (pa.length > 0) {
                      if (pa[0].GroupAdminType === 1) {
                        group.IsAdmin = true;
                      }
                      else {
                        group.IsAdmin = false;
                      }
                    }
                    else {
                      group.IsAdmin = false;
                    }

                  }
                  this.sdata.allgroups.push(group);
                }


              }


              this.sdata.allpools.sort(function compare(a, b) {
                let comparison = 0;
                if (a.LicensePoolName > b.LicensePoolName) {
                  comparison = 1;
                } else if (a.LicensePoolName < b.LicensePoolName) {
                  comparison = -1;
                }
                return comparison;
              });

              this.sdata.allgroups.sort(function compare(a, b) {
                let comparison = 0;
                if (a.LicensePoolGroupName > b.LicensePoolGroupName) {
                  comparison = 1;
                } else if (a.LicensePoolGroupName < b.LicensePoolGroupName) {
                  comparison = -1;
                }
                return comparison;
              })

              if (this.sdata.allorgs.length > 0 || this.sdata.allpools.length > 0 || this.sdata.allgroups.length > 0) {
                this.sdata.isloaded = true;
                localStorage.setItem("sdata", JSON.stringify(this.sdata));
                this.setupInbox();
                return true;
              }


            }

            if (this.sdata.poolthemes.length === 0) {
              this.sdata.poolthemes = adata.PoolThemes;
            }
          }
          debugger;
          this.failbackWithoutAlert();
          return new Promise(function (resolve, reject) { resolve(false); });
        })
      }
      catch (e) {        
        this.failback();
        return new Promise(function (resolve, reject) { resolve(false); });
      }

    },
    endLoading() {
      document.body.className = document.body.className.replace("loading", "");
    },
    failback() {
      localStorage.removeItem("udata");
      localStorage.removeItem("sdata");
      document.body.classList.add("login");
      window.alert("Your session has expired and you will be redirected to the login page");
      this.$router.push("/");
    },
    failbackWithoutAlert() {
      localStorage.removeItem("udata");
      localStorage.removeItem("sdata");
      document.body.classList.add("login");
      //window.alert("Your session has expired and you will be redirected to the login page");
      this.$router.push("/");
    },
    fixOpText(optext) {
      try {
        optext = optext.replace("DF5D501F-C823-4519-8B7F-260FCE4E0447".toLowerCase(), "Job Interview Training Site");
        optext = optext.replace("B9360F8C-7F67-4E0A-A3E4-2730AACE0412".toLowerCase(), "Training Center");
        optext = optext.replace("69A8D472-CD3F-49E6-9B68-354521067245".toLowerCase(), "Conversation Skills Site");
        optext = optext.replace("9ED395EA-6A5F-4BDF-AED4-98DA5B027950".toLowerCase(), "The Link Site");
        optext = optext.replace("F5C93017-42E1-420E-82A5-ACEE7666F1B4".toLowerCase(), "PeopleSimGames Site");
        optext = optext.replace("7728DEAD-2980-4748-9213-D49B97B74AE8".toLowerCase(), "Admin Center");
        optext = optext.replace("860671E6-F2A2-4BD0-882C-FBDDA52B6AE1".toLowerCase(), "Lifeline Site");
        optext = optext.replace("792858C2-B565-407A-BFFC-FF7F6AF9E810".toLowerCase(), "Intro Materials Site");

        if (optext.length > 100) {
          optext = optext.substring(0, 100) + "...";
        }

        return optext;
      }
      catch (e) {
        return "";
      }
    },
    getWonderProfile(checkTable) {
      var wdata = localStorage.getItem("wdata");
      if (wdata === null) {
        wdata = this.defaultWTProfile;
        localStorage.setItem("wdata", JSON.stringify(wdata));
      }
      else {

        wdata = JSON.parse(wdata);
        // Check to see if the table has been updated in the model, and if it has, rewrites the table settings
        if (checkTable !== null) {
          var needsReplace = false;
          try {
            if (wdata[checkTable].length !== this.defaultWTProfile[checkTable].length) {
              needsReplace = true;
            }
            else {
              for (var x = 0; x < wdata[checkTable].length; x++) {
                if (this.defaultWTProfile[checkTable].filter(p => p.id === wdata[checkTable][x].id).length === 0) {
                  needsReplace = true;
                }
              }
              for (var x = 0; x < this.defaultWTProfile[checkTable].length; x++) {
                if (wdata[checkTable].filter(p => p.id === this.defaultWTProfile[checkTable][x].id).length === 0) {
                  needsReplace = true;
                }
              }
            }
          }
          catch (e) {
            needsReplace = true;
          }
          if (needsReplace) {
            wdata[checkTable] = this.defaultWTProfile[checkTable];
            localStorage.setItem("wdata", JSON.stringify(wdata));
          }
        }
      }

      return wdata;
    },
    median(numbers) {
      var median = 0, numsLen = numbers.length;
      numbers.sort();
      if (
        numsLen % 2 === 0
      ) {
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
      } else {
        median = numbers[(numsLen - 1) / 2];
      }

      return median;
    },

    popDialog(typ, txt) {
      var self = this;
      self.$bus.$emit("ShowDialogEvent", typ, txt);
      window.setTimeout(function () {
        self.$bus.$emit("CloseDialogEvent");
      }, 5000);
      Window.loadLanguageContent(null, true);      
    },
    removeThemeSetting(cls, subcls) {
      try {
        document.getElementById("thm_" + cls + "_" + subcls).remove();
      }
      catch (e) { }
    },
    setupInbox() {
      this.updateInbox();
      var self = this;
      try {
        window.setInterval(function () { self.updateInbox(); }, 300000);
      }
      catch (e) { }
    },
    saveWonderProfile(wdata) {
      localStorage.setItem("wdata", JSON.stringify(wdata));
    },
    setWonderTableDefault(table) {
      var wdata = JSON.parse(localStorage.getItem("wdata"));
      wdata[table] = this.defaultWTProfile[table];
      localStorage.setItem("wdata", JSON.stringify(wdata));
    },
    startLoading() {
      document.body.classList.add("loading");
    },
    async updateInbox() {
      var self = this;

      if (this.udata === null) {
        try {
          this.udata = JSON.parse(localStorage.getItem("udata"));
        }
        catch (e) { }
      }

      // Check for expired session
      if (this.udata === null || typeof (this.udata.SessionID) === "undefined" || this.udata.expiry < new Date().getTime()) {
        return;
      }

      this.apiCommand([
        {
          Operation: "Client",
          Function: "GetUnreadMessageCount",
          Fields: {}
        }
      ], true).then(response => {

        var cr = JSON.parse(response.CommandResult);
        self.$bus.$emit("InboxBubbleEvent", parseInt(cr.returnObjects[0].returnObject));

      })
    }

  }
}

